export const UPDATE_AGENT_STATE = "UPDATE_AGENT_STATE"
export const AGENT_DELETED = "AGENT_DELETED"
export const NEW_AGENTS_ADDED = "NEW_AGENTS_ADDED"
export const UPDATE_ACTIVE_AGENT = "UPDATE_ACTIVE_AGENT"
export const AGENT_UPDATED = "AGENT_UPDATED"